(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * Listens to the 'share_intent' message, so other plugins can trigger share (suggestions).
     *
     * Displays the share button on the GUI too, displaying a dialog and allowing social and manual sharing of the video.
     *
     * @namespace sv_share
     */

    /**
     * @module Messages
     *
     * Listened by the sv_share plugin.
     * Opens share dialog programatically.
     *
     * @function share_intent
     * @param {String} messageKind='share_intent'
     */

    var _        = SAPO.Project.Video._,
        Css      = SAPO.Dom.Css,
        Event    = SAPO.Dom.Event,
        Feat     = SAPO.Project.Video.Features,
        Selector = SAPO.Dom.Selector;



    var plugin = function(vc, ui) {
        /*jshint maxstatements:90 */
        this._vc = vc;
        this._ui = ui;

        if (this._vc.getOption('skipShare')) { return; }

        this._vc.subscribe('button_activated metadata_changed share_intent', undefined, this);

        this._btnEl = this._ui.addButton('sv-share', 'right');


        // create markup
        var el = document.createElement('div');
        el.className = 'dialog dialog-sv-share hidden';

        var tEl = document.createElement('div');

        var divEl = document.createElement('div');
        divEl.className = 'row';

        tEl = document.createElement('span');
        tEl.className = 'd-title';
        tEl.appendChild( document.createTextNode( _('shareTitle') ) );
        divEl.appendChild(tEl);

        var xEl = document.createElement('div');
        xEl.className = 'dialog-close button x';
        divEl.appendChild(xEl);

        el.appendChild(divEl);


        divEl = document.createElement('div');
        divEl.className = 'row';

        tEl = document.createElement('label');
        tEl.appendChild( document.createTextNode( _('shareLinkTitle') ) );
        divEl.appendChild(tEl);

        var dEl = document.createElement('span');
        dEl.className = 'input-wrapper';

        tEl = document.createElement('input');
        tEl.type = 'text';
        dEl.appendChild(tEl);
        divEl.appendChild(dEl);
        var input0 = tEl;
        //input0.setAttribute('disabled', '');

        el.appendChild(divEl);


        divEl = document.createElement('div');
        divEl.className = 'row';

        tEl = document.createElement('label');
        tEl.appendChild( document.createTextNode( _('shareEmbedTitle') ) );
        divEl.appendChild(tEl);

        dEl = document.createElement('span');
        dEl.className = 'input-wrapper';

        tEl = document.createElement('input');
        tEl.type = 'text';
        dEl.appendChild(tEl);
        divEl.appendChild(dEl);
        var input1 = tEl;
        //input1.setAttribute('disabled', '');

        el.appendChild(divEl);


        divEl = document.createElement('div');
        divEl.className = 'row';

        tEl = document.createElement('label');
        tEl.appendChild( document.createTextNode( _('shareSocialTitle') ) );
        divEl.appendChild(tEl);

        var aEl = document.createElement('a');
        aEl.target = '_blank';
        aEl.setAttribute('rel', 'external');
        tEl = document.createElement('span');
        tEl.className = 'logo facebook';
        aEl.appendChild(tEl);
        divEl.appendChild(aEl);

        aEl = document.createElement('a');
        aEl.target = '_blank';
        aEl.setAttribute('rel', 'external');
        tEl = document.createElement('span');
        tEl.className = 'logo twitter';
        aEl.appendChild(tEl);
        divEl.appendChild(aEl);

        aEl = document.createElement('a');
        aEl.target = '_blank';
        aEl.setAttribute('rel', 'external');
        tEl = document.createElement('span');
        tEl.className = 'logo googleplus';
        aEl.appendChild(tEl);
        divEl.appendChild(aEl);

        el.appendChild(divEl);


        this._el = el;


        this._ui._els.aEl.appendChild(this._el);


        Event.observe(xEl, 'click', function(ev) {
            Event.stop(ev);
            Css.addClassName(   el,          'hidden');
            Css.removeClassName(this._btnEl, 'active');
        }.bindObj(this));


        if (Feat.hasTouchEvents) {
        //if (Feat.isIOS || (Feat.isAndroid && !Feat.isChromeForAndroid)) { // IOS or stock browser, let it be...
            return;
        }


        var onClick = function(ev) {
            var tgtEl = Event.element(ev);
            if (tgtEl.nodeName.toLowerCase() !== 'input') {
                tgtEl = tgtEl.firstChild;
            }
            Event.stop(ev);
            tgtEl.select();
        };

        var onChange = function(ev) {
            var tgtEl = Event.element(ev);
            tgtEl.value = (this._inputEls[0] === tgtEl) ? this._linkValue : this._embedValue;
            setTimeout(
                function() {
                    tgtEl.focus();
                    tgtEl.select();
                },
                0
            );
        }.bindObj(this);

        this._inputEls = [input0, input1];

        var iEl;
        for (var i = 0; i < 2; ++i) {
            iEl = this._inputEls[i];
            Event.observe(iEl.parentNode, 'mousedown',  onClick);
            //Event.observe(iEl.parentNode, 'touchstart', onClick);
            Event.observe(iEl,            'focus',      onClick);
            Event.observe(iEl,            'change',     onChange);
        }
    };



    plugin.prototype = {

        _name: plugin._name = 'sv_share',

        on_button_activated: function(mt, id) {
            if (id === 'sv-share' && this._md) {
                var hide = !Css.hasClassName(this._el, 'hidden');
                Css.setClassName(this._el,    'hidden',  hide);
                Css.setClassName(this._btnEl, 'active', !hide);
            }
        },
        on_metadata_changed: function(mt, md) {
            this._md = md;

            if (md.isAd) {
                this._ui.hideButton('sv-share');
                return;
            }
            else {
                this._ui.showButton('sv-share');
                var btnEl = this._btnEl;
                if (btnEl) {
                    btnEl.title = _('shareTitle');
                    this._btnEl = btnEl;
                }
            }

            if (!md.dimensions) {
                md.dimensions = [580, 326];
            }
            var w = md.dimensions[0];
            var h = md.dimensions[1];

            var title = md.title;
            var encTitle = encodeURIComponent(title);

            var pageUri = md.link;
            var encPageUri = encodeURIComponent(pageUri);

            var videoUri = [md.videoDomain, md.hash, 'mov', md.isLive ? '24' : '1'].join('/');


            var inputEls = Selector.select('input', this._el);
            var aEls     = Selector.select('a', this._el);


            // link
            this._linkValue = pageUri;
            inputEls[0].value = pageUri;

            // embed
            this._embedValue = ['<iframe src="http://rd3.videos.sapo.pt/playhtml?file=', videoUri, '" frameborder="0" scrolling="no" allowfullscreen width="', w, '" height="', h, '"></iframe>'].join('');
            inputEls[1].value = this._embedValue;

            // facebook
            aEls[0].href = ['https://www.facebook.com/dialog/feed?app_id=128738460473752&link=', encPageUri,
        '&feature=share&display=popup&redirect_uri=', encPageUri].join('');

            // twitter
            aEls[1].href = ['http://twitter.com/intent/tweet?text=', encTitle, ': ', '&related=sapo&via=sapo&url=', encPageUri].join('');

            // googleplus
            aEls[2].href = ['https://plus.google.com/share?url=', encPageUri, '&feature=share&source=sapovideos&hl=pt-PT'].join('');
        },

        on_share_intent: function() {
            Css.removeClassName(this._el, 'hidden');
        }
    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
